import React from 'react';

import styles from './Gauge.scss';
import limitValueInRange from './limitValueInRange';
import { PartialTr } from './types';

function gaugeBoxStyle(_startValue: number, _endValue: number, _minValue: number, _maxValue: number) {
  const [ startValue, endValue ] = [
    limitValueInRange(Math.min(_startValue, _endValue), [_minValue, _maxValue]),
    limitValueInRange(Math.max(_startValue, _endValue), [_minValue, _maxValue]) + 1
  ];
  const [ minValue, maxValue ] = [_minValue, _maxValue + 1];

  const diff = maxValue - minValue;
  return {
    width: `${(endValue - startValue) / diff * 100}%`,
    marginLeft: `${(startValue - minValue) / diff * 100}%`,
  };
}

interface GaugeProps {
  minValue: number;
  maxValue: number;
  startValue: number;
  endValue: number;
  setStartValue: (arg: number) => void;
  setEndValue: (args: number) => void;
  disabled?: boolean;
  tr: PartialTr;
}

const Gauge = ({minValue, maxValue, startValue, endValue, setStartValue, setEndValue, disabled, tr}: GaugeProps) => {
  if (minValue > maxValue) {
    throw new Error(`minValue is greater than maxValue: ${minValue} > ${maxValue}`);
  }

  return (
    <React.Fragment>
      {tr('from', '')}<input type="number" className={styles.input} min={minValue} max={maxValue} placeholder="year" disabled={disabled} required onChange={e => setStartValue(Number(e.target.value))} onBlur={e => setStartValue(limitValueInRange(Number(e.target.value), [minValue, maxValue]))} value={startValue} />
      {tr('to', '～')}<input type="number" className={styles.input} min={minValue} max={maxValue} placeholder="year" disabled={disabled} required onChange={e => setEndValue(Number(e.target.value))} onBlur={e => setEndValue(limitValueInRange(Number(e.target.value), [minValue, maxValue]))} value={endValue} />
      <div className={styles.spanGauge}>
        {minValue}
        <div className={styles.gaugeBox}>
          <div className={startValue <= endValue ? styles.gaugeBar : styles.gaugeBarNegative} style={gaugeBoxStyle(startValue, endValue, minValue, maxValue)}></div>
        </div>
        {maxValue}
      </div>
    </React.Fragment>
  );
};

export default Gauge;
